import { Helmet } from "react-helmet-async";

const PageNotFound = () => {
  return (
    <div>
      <Helmet>
        <title>{"Page not found | AMP"}</title>
      </Helmet>
      <h1 className="display-6">Page not found.</h1>
    </div>
  );
};

export default PageNotFound;
